import Phaser from "phaser";
import { GAME_WIDTH } from "../constants";
import { addCoverImage, addPanel } from "../ui/chrome";
import { MenuButton, bindMenuKeys } from "../ui/MenuButton";
import { bodyStyle, titleStyle } from "../ui/theme";
import { fetchHighScores } from "../services/leaderboardClient";
import { audioManager } from "../systems/AudioManager";
import type { PublicScore } from "../logic/leaderboard";

interface HighScoresData {
  you?: string;
}

export class HighScoresScene extends Phaser.Scene {
  private you: string | null = null;

  constructor() {
    super("HighScores");
  }

  init(data: HighScoresData): void {
    this.you = data.you ?? null;
  }

  create(): void {
    audioManager.playMusic("menu");
    addCoverImage(this, "menu-background");
    addPanel(this, GAME_WIDTH / 2, 350, 760, 600);
    this.add.text(GAME_WIDTH / 2, 86, "High Scores", titleStyle(44)).setOrigin(0.5).setColor("#2a1a10").setStroke("#000000", 0);

    const status = this.add.text(GAME_WIDTH / 2, 132, "Top ten hibernators", bodyStyle(18)).setOrigin(0.5);
    const listY = 172;

    void this.loadScores(status, listY);

    const back = new MenuButton(this, GAME_WIDTH / 2, 640, "Back", () => this.scene.start("Menu"), 220, "secondary");
    bindMenuKeys(this, [back]);
  }

  private async loadScores(status: Phaser.GameObjects.Text, listY: number): Promise<void> {
    const result = await fetchHighScores();
    if (!this.scene.isActive()) {
      return;
    }

    if (result.scores.length === 0) {
      status.setVisible(false);
      this.add.text(GAME_WIDTH / 2, 320, "No scores yet. Finish a cave run to be first!", bodyStyle(22)).setOrigin(0.5);
      return;
    }

    result.scores.forEach((entry, index) => this.drawRow(entry, listY + index * 36));
  }

  private drawRow(entry: PublicScore, y: number): void {
    const highlight = this.you !== null && entry.initials === this.you;
    if (highlight) {
      this.add.rectangle(GAME_WIDTH / 2, y, 620, 32, 0xe8b84a, 0.28);
    }
    const x = 360;
    if (entry.rank <= 3) {
      this.addRankBadge(entry.rank, x, y);
    } else {
      this.add.text(x, y, String(entry.rank), bodyStyle(20)).setOrigin(0.5);
    }
    this.add.text(430, y, entry.initials, bodyStyle(22)).setOrigin(0, 0.5);
    this.add.text(860, y, String(entry.score), bodyStyle(22)).setOrigin(1, 0.5);
  }

  private addRankBadge(rank: number, x: number, y: number): void {
    const key = rank === 1 ? "rank-badge-gold" : rank === 2 ? "rank-badge-silver" : "rank-badge-bronze";
    const badge = this.add.image(x, y, key);
    const height = 34;
    badge.setDisplaySize((badge.width / badge.height) * height, height);
    badge.setOrigin(0.5, 0.42);
  }
}
